import axios from 'axios';
import { settings } from '@/settings';

const API_SERVER = settings.API_SERVER;

export const api_routes = {
  user: {
    login: 'auth/login',
    signup: 'user/signup',
    me: 'user/me',
  },
};

export const apiCall = ({ url, method, ...args }) =>
  new Promise((resolve, reject) => {
    const token = localStorage.getItem('user-token') || '';
    const serverUrl = API_SERVER + url;

    try {
      if (token){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      }
      axios({
        method: method || 'get',
        url: serverUrl,
        ...args
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (err) {
      reject(new Error(err));
    }
  });
